import { type SVGProps } from "react";

export const IdCardLarge = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={168}
    height={168}
    fill="none"
    viewBox="0 0 168 168"
    {...props}
  >
    <circle cx={83.514} cy={85.516} r={64} fill="#F1F5F9" transform="rotate(5.116 83.514 85.516)" />
    <rect
      width={69.14}
      height={130.872}
      x={37.134}
      y={27.051}
      fill="#fff"
      rx={8}
      transform="rotate(-11.496 37.134 27.05)"
    />
    <path
      fill="#94A3B8"
      d="m44.394 50.569 62.986-12.81 10.335 50.815-62.986 12.81z"
      opacity={0.7}
    />
    <rect
      width={59.482}
      height={42.197}
      x={81.641}
      y={46.525}
      fill="#fff"
      stroke="#0F172A"
      strokeWidth={2.25}
      rx={3.225}
      transform="rotate(-1.248 81.64 46.525)"
    />
    <path
      fill="#B0BCCC"
      d="m83.376 80.513 57.558-1.025.088 5a2 2 0 0 1-1.964 2.034l-53.558.954a2 2 0 0 1-2.035-1.964l-.089-4.999ZM140.162 53.003l-57.208 1.5-.108-4.791a2.06 2.06 0 0 1 2.006-2.106l52.899-1.387a2.25 2.25 0 0 1 2.308 2.199l.103 4.585Z"
    />
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M102.982 73.725a7.491 7.491 0 0 0-5.983-2.975 7.489 7.489 0 0 0-5.981 2.975m11.964 0a9 9 0 1 0-11.965 0m11.965 0A8.97 8.97 0 0 1 96.999 76a8.966 8.966 0 0 1-5.981-2.275m8.981-8.975a3 3 0 1 1-5.998 0 3 3 0 0 1 5.998 0Z"
    />
    <circle
      cx={93.647}
      cy={131.469}
      r={4.939}
      fill="#0F172A"
      transform="rotate(-11.496 93.647 131.469)"
    />
    <path stroke="#000" strokeWidth={2} d="M111 63h23M111 67h17M111 71h19" />
    <rect
      width={66.14}
      height={127.872}
      x={38.903}
      y={28.222}
      stroke="#000"
      strokeWidth={3}
      rx={6.5}
      transform="rotate(-11.496 38.903 28.222)"
    />
  </svg>
);
